import React from 'react';
import { getTranslation } from '../../../../../utils/translation';

export default function ResultTable({
    total,
    debt,
    extraDebt,
    totalPayment,
    limitIncrease,
    credit,
    totalAgentCommission,
}) {
    return (
        <table className={'point-table h-full'} style={{ minHeight: '360px' }}>
            <thead>
                <tr style={{ height: '21px' }} />
            </thead>
            <tbody>
                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportTotalColumn')}
                    </td>
                    <td>{total}</td>
                </tr>
                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportAgentCommissionColumn')}
                    </td>
                    <td>{totalAgentCommission}</td>
                </tr>
                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportSummaryTablePaymentColumn')}
                    </td>
                    <td>{totalPayment}</td>
                </tr>

                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportSummaryTableLimitIncreaseColumn')}
                    </td>
                    <td>{limitIncrease ?? '-'}</td>
                </tr>

                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportSummaryTableCreditColumn')}
                    </td>
                    <td>{credit ?? '-'}</td>
                </tr>

                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportSummaryTableExtraDebtColumn')}
                    </td>
                    <td>{extraDebt ?? '-'}</td>
                </tr>

                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportSummaryTableDebtColumn')}
                    </td>
                    <td>{debt}</td>
                </tr>

                <tr align='left' className='reports-row'>
                    <td className='reports-leftCol'>
                        {getTranslation('balanceReportSummaryTableTotalDebtColumn')}
                    </td>
                    <td>{(parseFloat(extraDebt || '0') + parseFloat(debt || '0')).toFixed(2)}</td>
                </tr>
            </tbody>
        </table>
    );
}
